import moment from 'moment';
import { withNamespaces } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import {
    Button,
    Card,
    CardBody,
    Nav,
    NavItem,
    NavLink,
} from 'reactstrap';

import { ROUTE_PATH_ADMIN_GUARD_FREIGHTS_LIST } from 'src/modules/3rd-party-management/constants';
import { getCountryFlag } from '../../../constants';
import { CargoTypes, FreightStatuses } from '../../constants';

const tabs = [
    { key: 'overview', title: 'Overview' },
    { key: 'bids', title: 'Bids' },
    { key: 'documents', title: 'Documents' },
    { key: 'activity', title: 'Activity Log' },
];

const FreightHeader = ({
    activeTab,
    freight,
    onTabChange,
    t,
}) => {
    const history = useHistory();
    const status = FreightStatuses[freight.status];

    return (
        <Card>
            <CardBody className="pb-0">
                <Button
                    className="mb-3 p-0"
                    color="link"
                    onClick={() => history.push(ROUTE_PATH_ADMIN_GUARD_FREIGHTS_LIST)}
                    type="button"
                >
                    <i className="ri-arrow-left-line align-middle me-1" />
                    {t('Back to freights')}
                </Button>

                <div className="d-flex flex-wrap justify-content-between align-items-start gap-3">
                    <div className="d-flex align-items-start">
                        <div className="avatar-sm me-3">
                            <span className="avatar-title rounded bg-soft-primary text-primary font-size-24">
                                <i className="ri-truck-line" />
                            </span>
                        </div>

                        <div>
                            <div className="d-flex flex-wrap align-items-center gap-2 mb-2">
                                <h4 className="mb-0">{freight.reference}</h4>
                                <span className={`badge p-2 ${status.className}`}>
                                    <i className={`${status.icon} align-middle me-1`} />
                                    {t(status.title)}
                                </span>
                            </div>

                            <div className="d-flex flex-wrap align-items-center gap-2 text-muted mb-2">
                                <span className="d-flex align-items-center gap-1">
                                    <img
                                        alt={freight.origin.country}
                                        className="country-flag"
                                        src={getCountryFlag(freight.origin.country)}
                                    />
                                    {`${freight.origin.city}, ${freight.origin.country}`}
                                </span>
                                <i className="ri-arrow-right-line" />
                                <span className="d-flex align-items-center gap-1">
                                    <img
                                        alt={freight.destination.country}
                                        className="country-flag"
                                        src={getCountryFlag(freight.destination.country)}
                                    />
                                    {`${freight.destination.city}, ${freight.destination.country}`}
                                </span>
                            </div>

                            <div className="d-flex flex-wrap align-items-center gap-3 text-muted">
                                <span>
                                    <i className={`${CargoTypes[freight.cargo.type]} align-middle me-1`} />
                                    {t(freight.cargo.type)}
                                </span>
                                <span>
                                    <i className="ri-scales-2-line align-middle me-1" />
                                    {`${freight.cargo.weight.toLocaleString('en-US')} ${t('kg')}`}
                                </span>
                                <span>
                                    <i className="ri-calendar-line align-middle me-1" />
                                    {moment(freight.pickupDate).format('MMM D, YYYY')}
                                </span>
                                <span>
                                    <i className="ri-settings-3-line align-middle me-1" />
                                    {freight.cargo.loadType}
                                </span>
                            </div>
                        </div>
                    </div>

                    <div className="d-flex gap-2">
                        <Button color="secondary" outline type="button">
                            <i className="ri-share-line align-middle me-1" />
                            {t('Share')}
                        </Button>
                        <Button aria-label={t('More actions')} color="secondary" outline type="button">
                            <i className="ri-more-2-fill" />
                        </Button>
                    </div>
                </div>

                <Nav className="nav-tabs-custom mt-4" tabs>
                    {tabs.map((tab) => (
                        <NavItem key={tab.key}>
                            <NavLink
                                className={activeTab === tab.key ? 'active' : ''}
                                onClick={() => onTabChange(tab.key)}
                                style={{ cursor: 'pointer' }}
                            >
                                {t(tab.title)}
                                {tab.key === 'bids' && ` (${freight.verificationOverview.total})`}
                            </NavLink>
                        </NavItem>
                    ))}
                </Nav>
            </CardBody>
        </Card>
    );
};

export default withNamespaces()(
    FreightHeader
);
